// M13: maps a notification to the route of its originating record for the
// current user's portal. Frozen pages are never modified — we deep-link to
// detail routes where they exist and to the owning module page otherwise.
export const portalPrefix = (role) =>
  role === "recruiter" ? "/recruiter" : "/admin";

export const resolveNotificationLink = (n, role) => {
  const p = portalPrefix(role);
  const t = n.notification_type || "";
  if (t === "Admin Announcement" || t === "System Alert") return null;
  if (n.interview_id || t.startsWith("Interview") || t.startsWith("Candidate Sel") || t.startsWith("Candidate Rej")) {
    return `${p}/interviews`;
  }
  if (n.forward_lead_id || t.startsWith("Forward Lead")) return `${p}/forward-leads`;
  if (t === "Invoice Raised" || t === "Billing Ready" || t === "Payment Follow-up Due") {
    return role === "recruiter"
      ? (n.employment_id ? `${p}/employment/${n.employment_id}` : `${p}/employment`)
      : "/admin/billing";
  }
  if (t === "Joining Confirmed" || t === "Locking Follow-up Due") {
    return n.employment_id ? `${p}/employment/${n.employment_id}` : `${p}/employment`;
  }
  if (n.lineup_id || t === "Lineup Ready") return `${p}/lineups`;
  if (t === "Callback Due") return `${p}/followups`;
  if (t === "Task Overdue" || t === "Critical Task" || n.task_id) return `${p}/work-queue`;
  if (n.application_id) return `${p}/applications/${n.application_id}`;
  return null;
};
